<template>
  <router-link tag="li" class="nav-item nav-dropdown" :to="url">
    <div class="nav-link nav-dropdown-toggle"  :id="'drop'+name" @click="handleClick"><i :class="icon"></i><i> </i>{{name}}</div>
    <ul class="nav-dropdown-items">
      <slot></slot>
    </ul>
  </router-link>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// SidebarNavDropdown.vue?47e02c92